/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RequestPasswordResetRouteImport } from './routes/request-password-reset'
import { Route as NewUserSetupRouteImport } from './routes/new-user-setup'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LegalLicensesRouteImport } from './routes/legal/licenses'
import { Route as CustomersCustomerIdMachinesMachineIdRouteImport } from './routes/customers/$customerId/machines/$machineId'
import { Route as CustomersCustomerIdRequestsRequestIdIndexRouteImport } from './routes/customers/$customerId/requests/$requestId/index'

const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const RequestPasswordResetRoute = RequestPasswordResetRouteImport.update({
  id: '/request-password-reset',
  path: '/request-password-reset',
  getParentRoute: () => rootRouteImport,
} as any)
const NewUserSetupRoute = NewUserSetupRouteImport.update({
  id: '/new-user-setup',
  path: '/new-user-setup',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalLicensesRoute = LegalLicensesRouteImport.update({
  id: '/legal/licenses',
  path: '/legal/licenses',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomersCustomerIdMachinesMachineIdRoute =
  CustomersCustomerIdMachinesMachineIdRouteImport.update({
    id: '/customers/$customerId/machines/$machineId',
    path: '/customers/$customerId/machines/$machineId',
    getParentRoute: () => rootRouteImport,
  } as any)
const CustomersCustomerIdRequestsRequestIdIndexRoute =
  CustomersCustomerIdRequestsRequestIdIndexRouteImport.update({
    id: '/customers/$customerId/requests/$requestId/',
    path: '/customers/$customerId/requests/$requestId/',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/new-user-setup': typeof NewUserSetupRoute
  '/request-password-reset': typeof RequestPasswordResetRoute
  '/reset-password': typeof ResetPasswordRoute
  '/legal/licenses': typeof LegalLicensesRoute
  '/customers/$customerId/machines/$machineId': typeof CustomersCustomerIdMachinesMachineIdRoute
  '/customers/$customerId/requests/$requestId/': typeof CustomersCustomerIdRequestsRequestIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/new-user-setup': typeof NewUserSetupRoute
  '/request-password-reset': typeof RequestPasswordResetRoute
  '/reset-password': typeof ResetPasswordRoute
  '/legal/licenses': typeof LegalLicensesRoute
  '/customers/$customerId/machines/$machineId': typeof CustomersCustomerIdMachinesMachineIdRoute
  '/customers/$customerId/requests/$requestId': typeof CustomersCustomerIdRequestsRequestIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/new-user-setup': typeof NewUserSetupRoute
  '/request-password-reset': typeof RequestPasswordResetRoute
  '/reset-password': typeof ResetPasswordRoute
  '/legal/licenses': typeof LegalLicensesRoute
  '/customers/$customerId/machines/$machineId': typeof CustomersCustomerIdMachinesMachineIdRoute
  '/customers/$customerId/requests/$requestId/': typeof CustomersCustomerIdRequestsRequestIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/new-user-setup'
    | '/request-password-reset'
    | '/reset-password'
    | '/legal/licenses'
    | '/customers/$customerId/machines/$machineId'
    | '/customers/$customerId/requests/$requestId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/new-user-setup'
    | '/request-password-reset'
    | '/reset-password'
    | '/legal/licenses'
    | '/customers/$customerId/machines/$machineId'
    | '/customers/$customerId/requests/$requestId'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/new-user-setup'
    | '/request-password-reset'
    | '/reset-password'
    | '/legal/licenses'
    | '/customers/$customerId/machines/$machineId'
    | '/customers/$customerId/requests/$requestId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  NewUserSetupRoute: typeof NewUserSetupRoute
  RequestPasswordResetRoute: typeof RequestPasswordResetRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  LegalLicensesRoute: typeof LegalLicensesRoute
  CustomersCustomerIdMachinesMachineIdRoute: typeof CustomersCustomerIdMachinesMachineIdRoute
  CustomersCustomerIdRequestsRequestIdIndexRoute: typeof CustomersCustomerIdRequestsRequestIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/request-password-reset': {
      id: '/request-password-reset'
      path: '/request-password-reset'
      fullPath: '/request-password-reset'
      preLoaderRoute: typeof RequestPasswordResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/new-user-setup': {
      id: '/new-user-setup'
      path: '/new-user-setup'
      fullPath: '/new-user-setup'
      preLoaderRoute: typeof NewUserSetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal/licenses': {
      id: '/legal/licenses'
      path: '/legal/licenses'
      fullPath: '/legal/licenses'
      preLoaderRoute: typeof LegalLicensesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers/$customerId/machines/$machineId': {
      id: '/customers/$customerId/machines/$machineId'
      path: '/customers/$customerId/machines/$machineId'
      fullPath: '/customers/$customerId/machines/$machineId'
      preLoaderRoute: typeof CustomersCustomerIdMachinesMachineIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers/$customerId/requests/$requestId/': {
      id: '/customers/$customerId/requests/$requestId/'
      path: '/customers/$customerId/requests/$requestId'
      fullPath: '/customers/$customerId/requests/$requestId/'
      preLoaderRoute: typeof CustomersCustomerIdRequestsRequestIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  NewUserSetupRoute: NewUserSetupRoute,
  RequestPasswordResetRoute: RequestPasswordResetRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  LegalLicensesRoute: LegalLicensesRoute,
  CustomersCustomerIdMachinesMachineIdRoute:
    CustomersCustomerIdMachinesMachineIdRoute,
  CustomersCustomerIdRequestsRequestIdIndexRoute:
    CustomersCustomerIdRequestsRequestIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
